import { render, staticRenderFns } from "./QuotaSpecBindingPropertyPanel.vue?vue&type=template&id=49b12326&"
import script from "./QuotaSpecBindingPropertyPanel.vue?vue&type=script&lang=js&"
export * from "./QuotaSpecBindingPropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemTitle})
